<script>
  let name;
  let email;
  let subject;
  let message;

  function onSubmitForm() {
    const params = JSON.stringify({
      name,
      email,
      subject,
      message,
    });

    fetch(`https://us-central1-afanjou-7181c.cloudfunctions.net/sendMailMessage?params=${params}`);

    name = '';
    email = '';
    subject = '';
    message = '';

    toastr.success('Votre message a été transmis avec succès !');
  }
</script>

<section id="contact" class="contact section-bg">
    <div class="container">

      <div class="section-title" data-aos="fade-in" data-aos-delay="100">
        <h2>Contact</h2>
        <p>Nous sommes disponibles pour vous servir 7/7 365 jours par année !</p>
      </div>

      <div class="row" data-aos="fade-up" data-aos-delay="100">
        <div class="col-lg-6">
          <div class="info-box mb-4">
            <i class="bx bx-map"></i>
            <h3>Notre adresse</h3>
            <p>8330 Boulevard Parkway, Anjou, QC H1J 1N2</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="info-box  mb-4">
            <i class="bx bx-envelope"></i>
            <h3>Courriel</h3>
            <p>contact@afanjou.ca</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="info-box  mb-4">
            <i class="bx bx-phone-call"></i>
            <h3>Téléphone</h3>
            <p>+1 (438) 395-7522</p>
          </div>
        </div>

      </div>

      <div class="row" data-aos="fade-up" data-aos-delay="200">

        <div class="col-lg-6 ">
          <iframe class="mb-4 mb-lg-0" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=8330%20Bd%20Parkway,%20Anjou,%20QC%20H1J%201N2+(Centre%20Taqwa)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" frameborder="0" style="border:0; width: 100%; height: 100%;" allowfullscreen></iframe>
        </div>

        <div class="col-lg-6">
          <form class="php-email-form">
            <div class="form-row">
              <div class="col-md-6 form-group">
                <input type="text" name="name" class="form-control" id="name" bind:value={name} placeholder="Votre nom" data-rule="minlen:4" data-msg="Entrez au moins 4 charactères" />
                <div class="validate"></div>
              </div>
              <div class="col-md-6 form-group">
                <input type="email" class="form-control" name="email" id="email" bind:value={email} placeholder="Votre courriel" data-rule="email" data-msg="Entrez un courriel valide" />
                <div class="validate"></div>
              </div>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" name="subject" id="subject" bind:value={subject} placeholder="Sujet" data-rule="minlen:4" data-msg="Svp entrez au moins 8 charactès dans votre sujet" />
              <div class="validate"></div>
            </div>
            <div class="form-group">
              <textarea class="form-control" name="message" bind:value={message} rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message"></textarea>
              <div class="validate"></div>
            </div>
            <div class="text-center"><button on:click|preventDefault={onSubmitForm} type="submit">Envoyer message</button></div>
          </form>
        </div>

      </div>

    </div>
  </section>
